import asyncActionTypes from './types.js';

export const openModalSignUp = ( response ) => ({
  type: asyncActionTypes.OPEN_MODAL_SIGNUP.SUCCESS,
  payload: response,
});

export const modalSignUpMethod = ( response ) => ({
  type: asyncActionTypes.OPEN_MODAL_SIGNUP_METHOD.SUCCESS,
  payload: response,
});

export function setOpenModalSignUp(options) {
  return function action(dispatch) {
    dispatch(openModalSignUp(options));
  };
}

export function setModalSignUpMethod(options) {
  return function action(dispatch) {
    dispatch(modalSignUpMethod(options));
  };
}